import { RadioOverrides } from 'baseui/radio';

export const RADIO: RadioOverrides = {
  Label: {
    style: {
      width: '100%',
    },
  },
  Description: {
    style: {
      width: 'inherit',
      maxWidth: 'inherit',
      marginTop: '4px',
      marginBottom: '8px',
    },
  },
  Input: {
    style: {
      display: 'none',
    },
  },
};
